import toastr from "toastr";

import moment from "moment";

import _ from 'lodash';

import TaskModalView from "./taskModal.html";
import SelectEventModalView from "./selectEventModal.html";
import HistoricMailsModalView from "../common/historicMails.html";

angular.module("events")


    .filter('formatTaskUsers', function () {
        return function (taskUser) {
            var ret = "";
            ret += "<b>" + taskUser.FK_events_tasks_users_users.name + "</b>";
            if (taskUser.FK_events_tasks_users_users.mail != null) ret += "<br><a href='mailto:" + taskUser.FK_events_tasks_users_users.mail + "' class='btn btn-default btn-xs'><i class='fa fa-envelope' /> Enviar correo</a>";
            return ret;
        };
    })

    .controller("EventsTasksListCtrl", ['LoginService', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$stateParams', '$state', 'uiGridConstants', '$timeout', '$q', '$http', 'uiGridTreeViewConstants', 'treeService', '$sce', '$location', '$window', 'logService',
        function (LoginService, $rootScope, $scope, Restangular, gridService, modalService, $uibModal, $filter, $translate, $stateParams, $state, uiGridConstants, $timeout, $q, $http, uiGridTreeViewConstants, treeService, $sce, $location, $window, logService) {

            // Comprobamos si han venido a través de la url externa
            let task_id = $location.$$search.task_id;

            logService.debug(task_id);

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("EVENTS_TASKS_WRITE");

            if (!Array.isArray($scope.$parent.menusItems)) {

                $state.go("events.edit", { id: $stateParams.id });

            } else {
                let results = $scope.$parent.menusItems.filter(m => m.id === parseInt($stateParams.menu_item_id, 10));
                if (results.length > 0) {
                    $scope.allowWrite &&= results[0].editable;
                } else {
                    $scope.allowWrite = false;
                }
            }

            $scope.gantt_data = [];
            $scope.diagramView = false;

            $scope.showDiagram = function (val) {
                $scope.diagramView = val;
            }

            $scope.headersFormats = {
                'year': 'YYYY',
                month: 'MM / YYYY',
                day: 'D',
            };

            //Solo se carga todo esto si estamos en tasks, así evitamos que lo incluyan los calendarios.
            if ($state.current.name == 'events.edit.tasks') {
                Restangular.one('Events', $stateParams.id).get().then(function (results) {
                    $scope.event = results;
                    $rootScope.breadcrumb = [
                        { title: $filter('translate')('events.title'), url: "events.list" },
                        { title: $scope.event.name, url: "events.edit({ id: " + $scope.event.id + " })" },
                        { title: $filter('translate')('events.tasks.tasks') }
                    ];
                    $rootScope.title = $scope.event.name + " - " + $filter('translate')('events.tasks.tasks');
                });

                $scope.task = {};
                $scope.getToday = new Date();
                $scope.currentDate = "line";
                $scope.viewScale = "day";
                $scope.classSize = "col-lg-12 col-md-12";

                let isDefinedAndNotNull = function (val: any) {
                    return angular.isDefined(val) && val !== null;
                }

                $scope.statusOptions = [];
                Restangular.all('TasksStatus').getList({ entity_type: "events" }).then(function (results) {
                    angular.forEach(results, function (statusOption) {
                        $scope.statusOptions.push({
                            value: statusOption.id,
                            label: statusOption.name
                        });
                    });

                });

                var initialized = false;

                $scope.pdfMaker = function () {
                    //$('html, body').scrollTop(0);

                    var container = angular.element('#gantt-container');

                    $("#gantt-container #gantt-to-export .gantt-row-label").css("font-size", "25px").css("height", "50").css("color", "#000000");
                    $("#gantt-container #gantt-to-export .gantt-row-height").css("font-size", "24px").css("height", "50").css("color", "#000000");
                    $("#gantt-container #gantt-to-export .gantt-task .gantt-task-content > span > font").hide()
                    $("#gantt-container #gantt-to-export .gantt-header-row").css("font-size", "25px").css("height", "50").css("color", "#000000");
                    $("#gantt-container #gantt-to-export .gantt-tree-handle-button").hide();//ocultamos el desplegable.

                    var widthShow = angular.element("#gantt-to-export .gantt-side").width() + $("#gantt-container-shown .gantt-scrollable")[0].scrollWidth;
                    logService.debug(widthShow);
                    widthShow = widthShow + 1000;
                    logService.debug(widthShow);


                    $("#gantt-container #gantt-to-export").css("width", widthShow); //Le pongo el tamaño de lo que se visualiza!!
                    container.show();

                    logService.debug("height: " + angular.element('#gantt-container #gantt-to-export').height());

                    // @ts-ignore
                    html2canvas(document.querySelector("#gantt-to-export")).then(canvas => {
                        var data = canvas.toDataURL("image/png", 1.0);
                        var docDefinition = {
                            pageSize: {
                                width: widthShow + 500,
                                height: angular.element('#gantt-to-export').height() + 1000//height
                            },
                            content: [{
                                image: data,
                                width: widthShow + 200
                            }]
                        };
                        // @ts-ignore
                        pdfMake.createPdf(docDefinition).download("gantt.pdf");
                        container.hide();

                    });
                }

                $scope.is_template = $stateParams.is_template == 'true';
                $scope.gridOptionsEventTasks = {
                    pdfTitle: function () { return $scope.event.name + " - " + $filter('translate')('events.tasks.pdf_title'); },
                    exporterMenuCsv: true,
                    enableGridMenu: true,
                    showTreeExpandNoChildren: false,
                    enableSorting: true,
                    paginationPageSizes: [100, 200, 300],
                    paginationPageSize: 100,
                    onRegisterApi: function (gridApi) {
                        this.gridApi = gridApi;
                    },
                    exporterFieldCallback: function (grid, row, col, value) {
                        var valueReturned = "";
                        if (col.name == 'users') {
                            if (angular.isDefined(row.entity.FK_events_tasks_users_events_tasks) && row.entity.FK_events_tasks_users_events_tasks.length > 0) {
                                row.entity.FK_events_tasks_users_events_tasks.forEach(function (item) {
                                    if (valueReturned != "" && item.FK_events_tasks_users_users.name != "") valueReturned += ", ";
                                    valueReturned += item.FK_events_tasks_users_users.name;
                                });
                            }
                            return valueReturned;
                        } else if (col.name == "title") {
                            if (!row.entity.is_group) {
                                return "-- " + value;
                            } else {
                                return value;
                            }
                        } else if (col.name == "task_status_name" && !row.entity.is_group) {

                            if (angular.isDefined(row.entity.FK_events_tasks_tasks_status)) {
                                if (row.entity.FK_events_tasks_tasks_status.code == "COMPLETED") {
                                    return $filter('translate')('events.tasks.completed');
                                } else if (row.entity.FK_events_tasks_tasks_status.code == "CANCELED") {
                                    return $filter('translate')('events.tasks.canceled');
                                } else if (row.entity.FK_events_tasks_tasks_status.code == "IN_PROGRESS") {
                                    return $filter('translate')('events.tasks.work_progress') + " " + row.entity.work_progress + "%";

                                } else if (row.entity.FK_events_tasks_tasks_status.code == "PENDING") {

                                    return $filter('translate')('events.tasks.pending');
                                } else {
                                    return "";
                                }
                            }
                            return value;
                        } else {
                            return value
                        }
                    },
                    columnDefs: [
                        { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                        {
                            name: 'title', displayName: $filter('translate')('events.tasks.title_field'), enableFiltering: true, enableHiding: false, enableColumnMenu: false,
                            minWidth: 150,
                            cellTemplate: '<div class="ui-grid-cell-contents"><a class="aColorBlack" popover-placement="top" popover-trigger="mouseenter click outsideClick" uib-popover-html="row.entity.title" popover-append-to-body="true">{{row.entity.title}}</a></div>',
                        },
                        {
                            name: 'users', enableSorting: false, displayName: $filter('translate')('events.tasks.persons'), enableFiltering: true, enableColumnMenu: false,
                            //cellTemplate: '<div class="ui-grid-cell-contents"><img ng-repeat="taskUser in row.entity.FK_events_tasks_users_events_tasks" popover-placement="top" popover-popup-close-delay="2" popover-trigger="click outsideClick" uib-popover-html="taskUser | formatTaskUsers" popover-append-to-body="true" ng-src="{{taskUser.FK_events_tasks_users_users.photo}}" class="img-circle margin-right-2" height="100%"></div>',
                            cellTemplate: '<div class="ui-grid-cell-contents"><img ng-repeat="taskUser in row.entity.FK_events_tasks_users_events_tasks" popover-placement="top" popover-popup-close-delay="2" popover-trigger="click outsideClick" uib-popover-html="taskUser | formatTaskUsers" popover-append-to-body="true" ng-src="' + (window as any).CONFIG.api_url + '/Users/GetImageUser?id={{taskUser.user_id}}" class="img-circle margin-right-2" height="100%"></div>',
                            maxWidth: 120, enableHiding: !$scope.is_template, visible: !$scope.is_template
                        },
                        { name: 'color', displayName: $filter('translate')('general.color'), enableFiltering: false, cellTemplate: gridService.colorTemplate("color"), maxWidth: 50 },
                        {
                            name: 'date_from', displayName: $filter('translate')('events.date_from'), enableFiltering: false,
                            cellTemplate: '<div class="ui-grid-cell-contents" ng-if="row.entity.all_day">{{row.entity.date_from | toLocalDate | date:"dd/MM/yy"}}</div>' +
                                '<div class="ui-grid-cell-contents" ng-if="!row.entity.all_day">{{row.entity.date_from | toLocalDate | date:"dd/MM/yy HH:mm"}}</div>',
                            maxWidth: 105, minWidth: 75, enableHiding: !$scope.is_template, visible: !$scope.is_template,
                            customFormatFn: function (value) {
                                if (value != null) {
                                    var fecha = new Date(value);
                                    if (fecha.getHours() != 0) {
                                        return $filter('date')(fecha, 'dd/MM/yy HH:mm');
                                    } else {
                                        return $filter('date')(fecha, 'dd/MM/yy');
                                    }

                                }
                                return "";
                            },
                        },
                        {
                            name: 'date_to', displayName: $filter('translate')('events.date_to'), enableFiltering: false,
                            cellTemplate: '<div class="ui-grid-cell-contents" ng-if="row.entity.all_day">{{ row.entity.date_to | toLocalDate | date:"dd/MM/yy"}}</div>' +
                                '<div class="ui-grid-cell-contents" ng-if="!row.entity.all_day">{{ row.entity.date_to | toLocalDate | date:"dd/MM/yy HH:mm"}}</div>',
                            maxWidth: 105, minWidth: 75, enableHiding: !$scope.is_template, visible: !$scope.is_template,
                            customFormatFn: function (value) {
                                if (value != null) {
                                    var fecha = new Date(value);
                                    if (fecha.getHours() != 0) {
                                        return $filter('date')(fecha, 'dd/MM/yy HH:mm');
                                    } else {
                                        return $filter('date')(fecha, 'dd/MM/yy');
                                    }
                                }
                                return "";
                            },
                            enableColumnMenu: false
                        },
                        {
                            name: 'task_status_name', enableFiltering: true, filter: { selectOptions: $scope.statusOptions, type: uiGridConstants.filter.SELECT },
                            displayName: $filter('translate')('events.tasks.task_status'), cellTemplate: '<div class="ui-grid-cell-contents" ng-if="row.entity.FK_events_tasks_tasks_status.code == \'PENDING\' && !row.entity.is_group"><a class="aColorBlack" popover-placement="top" popover-trigger="mouseenter click outsideClick" uib-popover-html="row.entity.FK_events_tasks_tasks_status.FK_tasks_status_tl_tasks_status[0].name" popover-append-to-body="true"><label style="display: block; padding-top: 5px; padding-bottom: 5px; overflow:hidden;" class="label label-warning">&nbsp;</label></a></div>' +
                                '<div class="ui-grid-cell-contents" ng-if="row.entity.FK_events_tasks_tasks_status.code == \'COMPLETED\' && !row.entity.is_group"><a class="aColorBlack" popover-placement="top" popover-trigger="mouseenter click outsideClick" uib-popover-html="row.entity.FK_events_tasks_tasks_status.FK_tasks_status_tl_tasks_status[0].name" popover-append-to-body="true"><label style="display: block; padding-top: 5px; padding-bottom: 5px; overflow:hidden;" class="label label-primary">&nbsp;</label></a></div>' +
                                '<div class="ui-grid-cell-contents" ng-if="row.entity.FK_events_tasks_tasks_status.code == \'CANCELED\' && !row.entity.is_group"><a class="aColorBlack" popover-placement="top" popover-trigger="mouseenter click outsideClick" uib-popover-html="row.entity.FK_events_tasks_tasks_status.FK_tasks_status_tl_tasks_status[0].name" popover-append-to-body="true"><label style="display: block; padding-top: 5px; padding-bottom: 5px; overflow:hidden;" class="label label-danger">&nbsp;</label></a></div>' +
                                '<div class="ui-grid-cell-contents" ng-if="row.entity.FK_events_tasks_tasks_status.code == \'IN_PROGRESS\' && !row.entity.is_group">' +
                                '<div class="progress progress-striped" style="background-color: #e6e6e6;"><a class="aColorBlack" popover-placement="top" popover-trigger="mouseenter click outsideClick" uib-popover-html="row.entity.work_progress" popover-append-to-body="true"><div ng-style="{\'width\': row.entity.work_progress + \'%\'}" aria-valuemax="100" aria-valuemin="0" aria-valuenow="{{row.entity.work_progress}}" role="progressbar" class="progress-bar progress-bar-warning"></div></a></div>' +
                                '</div>',
                            width: 40, enableHiding: !$scope.is_template, visible: !$scope.is_template,
                            enableColumnMenu: false
                        },
                        {
                            name: ' ', width: 40, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionIconTemplate([
                                { title: "", action: ' ng-click="grid.appScope.duplicateEventTask(row.entity.id)" ng-if="grid.appScope.allowWrite && row.entity.id != null && row.entity.is_group" style="padding: 1px 0px"', cssIconClass: "fa fa-copy" },
                                { title: "", action: ' ng-click="grid.appScope.addEventTask(row.entity.id)" ng-if="grid.appScope.allowWrite && row.entity.id != null" style="padding: 1px 0px"', cssIconClass: "fa fa-edit" },
                                { title: "", action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.title);" ng-if="grid.appScope.allowWrite && row.entity.id != null" style="padding: 1px 0px"', cssIconClass: "fa fa-remove" }
                            ], { cssClass: "pull-right" })
                        },
                    ],
                    getData: function (options) {
                        var deferred = $q.defer();

                        options.dateFrom1 = $scope.dateFrom1;
                        options.dateFrom2 = $scope.dateFrom2;
                        options.dateTo1 = $scope.dateTo1;
                        options.dateTo2 = $scope.dateTo2;
                        options.event_id = $stateParams.id;
                        Restangular.all('EventsTasks').getList(options).then(function (result) {
                            let userIds = new Array();
                            $scope.gantt_data = [];
                            var no_group = {
                                id: null,
                                title: $filter('translate')('events.tasks.without_group'),
                                event_task_id: null,
                                is_group: true
                            };

                            _.every(result, function (event_task) {
                                //Creamos el grupo "Sin grupo si alguien no tiene grupo y no ha sido creado"
                                if (!event_task.is_group && event_task.event_task_id == null) {
                                    result.unshift(no_group);
                                    return false;
                                }

                                return true;
                            });

                            //GANT
                            if (!$scope.is_template) {
                                angular.forEach(result, function (event_task) {

                                    if (event_task.is_group) {
                                        $scope.gantt_data.push({
                                            name: event_task.title,
                                            color: "#bab9b5",//"#ecba52",
                                            height: "2em"
                                        });
                                        if(event_task.color != null) $scope.gantt_data[$scope.gantt_data.length - 1].color = event_task.color;
                                        if (event_task.id != null) {
                                            angular.forEach(result, function (event_task_2) {

                                                if (!event_task_2.is_group && (event_task_2.event_task_id == event_task.id) && event_task_2.date_from != null) {
                                                    addToGantt(event_task, event_task_2);
                                                }
                                            });
                                        }

                                    } else if (event_task.event_task_id == null && event_task.date_from != null) {
                                        addToGantt(no_group, event_task);
                                    }
                                });
                            }
                            var treeEventTasks = [];
                            var data = treeService.eventTasksTree(result, null, treeEventTasks);
                            var contParents = 0;
                            angular.forEach(data, function (eventTask) {
                                if (eventTask.is_group) {
                                    contParents = contParents + 1;
                                }
                            });
                            data.totalRows = contParents;

                            $timeout(function () {
                                $scope.gridOptionsEventTasks.gridApi.treeBase.expandAllRows();
                                //initialized = true;
                            }, 1500);
                            deferred.resolve(data);
                        });
                        return deferred.promise;

                    }
                };


                var addToGantt = function (event_task, event_task_2) {
                    logService.debug(event_task_2)
                    if (event_task_2.date_to == null || typeof event_task_2.date_to == "undefined") event_task_2.date_to = moment(event_task_2.date_from).add(1, 'days');
                    var contentTooltip = "";
                    contentTooltip += "<b>" + event_task_2.title + "</b></br>"
                    contentTooltip += "Desde: " + moment(event_task_2.date_from).format("DD/MM/YYYY HH:mm") + "</br>";
                    contentTooltip += "Hasta: " + moment(event_task_2.date_to).format("DD/MM/YYYY HH:mm") + "</br>"
                    contentTooltip += "Personas: ";
                    angular.forEach(event_task_2.FK_events_tasks_users_events_tasks, function (user) {
                        contentTooltip += user.FK_events_tasks_users_users.name + ", ";
                    });
                    contentTooltip = contentTooltip.slice(0, -2);

                    var color = "";
                    if (event_task_2.FK_events_tasks_tasks_status.code == 'CANCELED') color = "#ed5565";
                    if (event_task_2.FK_events_tasks_tasks_status.code == 'COMPLETED') color = "#1ab394";
                    if (event_task_2.FK_events_tasks_tasks_status.code == 'PENDING' || event_task_2.FK_events_tasks_tasks_status.code == 'IN_PROGRESS') color = "#f8ac59";

                    if(event_task_2.color != null) color = event_task_2.color;
                    
                    $scope.gantt_data.push({
                        name: event_task_2.title,
                        parent: event_task.title,
                        tasks: [{
                            task_id: event_task_2.id,
                            name: event_task_2.title,
                            color: color,
                            progress: (event_task_2.FK_events_tasks_tasks_status.code == 'IN_PROGRESS') ? event_task_2.work_progress : "",
                            content: "<font color='white'>" + event_task_2.title + "</font>",
                            contentTooltip: $sce.trustAsHtml(contentTooltip),
                            from: moment(event_task_2.date_from),
                            to: moment(event_task_2.date_to)
                        }]
                    });
                }

                //API gantt
                $scope.registerApi = function (api) {
                    logService.debug("registerApi");
                    $scope.api = api;
                    api.directives.on.new($scope, function (dName, dScope, dElement, dAttrs, dController) {
                        if (dName === 'ganttTask') {
                            dElement.bind('click', function (event) {
                                logService.debug("entra aqui en task-list.js linea324");
                                $scope.addEventTask(dScope.task.model.task_id);

                            });
                        }
                    });
                };

            }//solo si estamos en el current.name de tasklist.

            $scope.addEventTask = function (id) {

                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: TaskModalView,
                    controller: "EventTaskModalCtrl",
                    size: 'lg',
                    resolve: {
                        event_task_id: function () {
                            return id;
                        },
                        event_id: function () {
                            return $stateParams.id;
                        },
                        type: function () {
                            return "task";
                        }
                    }

                });

                //Retorno de los datos desde el modal.
                $modalInstance.result.then(function (resultModal) {
                    if ($state.current.name == 'events.edit.tasks') {
                        if (angular.isDefined($scope.gridOptionsEventTasks.gridApi)) {
                            $scope.gridOptionsEventTasks.gridApi.core.raise.itemChanged($scope);
                            $scope.gridOptionsEventTasks.gridApi.treeBase.expandAllRows();
                        }
                        if (!$scope.is_template) $scope.$parent.loadInfo($stateParams.id);
                    }

                    if (typeof $scope.refetchEvents == 'function') $scope.refetchEvents();

                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    //  $scope.identity = {};
                });

            };

            
                if (task_id != null) {
                    $scope.addEventTask(task_id);
                }
            
            

            $scope.duplicateEventTask = function (id) {

                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: SelectEventModalView,
                    controller: "EventSelectModalCtrl",
                    size: 'lg'
                });

                $modalInstance.result.then(function (event) {
                    Restangular.all('EventsTaks').customPOST({}, "DuplicateTask", { id: id, event_id: event.event.id }).then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('events.tasks.create_success'));
                            $scope.gridOptionsEventTasks.loadData();
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    //  $scope.identity = {};
                });

            }

            /*
             * Si lleva el parámetro abro el elemento
             */
            if (angular.isDefined($stateParams.taskId) && $stateParams.taskId != null && $stateParams.taskId != "")
                $scope.addEventTask($stateParams.taskId)


            $scope.addEventTaskGroup = function (id) {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: TaskModalView,
                    controller: "EventTaskModalCtrl",
                    size: 'lg',
                    resolve: {
                        event_task_id: function () {
                            return id;
                        },
                        event_id: function () {
                            return $stateParams.id;
                        },
                        type: function () {
                            return "group";
                        }
                    }

                });

                //Retorno de los datos desde el modal.
                $modalInstance.result.then(function (resultModal) {
                    if (angular.isDefined($scope.gridOptionsEventTasks.gridApi)) {
                        $scope.gridOptionsEventTasks.gridApi.core.raise.itemChanged($scope);
                        $scope.gridOptionsEventTasks.gridApi.treeBase.expandAllRows();
                    }
                    if (typeof $scope.refetchEvents == 'function') $scope.refetchEvents();
                    if (!$scope.is_template) $scope.$parent.loadInfo($stateParams.id);

                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    //  $scope.identity = {};
                });

            };


            //Delete desde el listado
            $scope.deleteDialog = function (id, title) {

                modalService.confirm({
                    title: $filter('translate')('events.tasks.button_delete'),
                    message: $filter('translate')('events.tasks.delete_message') + " " + title + "?",
                    onAccept: function () {
                        Restangular.one('EventsTasks', id).remove().then(function () {
                            toastr.success($filter('translate')('events.tasks.deleted_success'));
                            if (angular.isDefined($scope.gridOptionsEventTasks.gridApi)) {
                                $scope.gridOptionsEventTasks.gridApi.core.raise.itemChanged($scope);
                                $scope.gridOptionsEventTasks.gridApi.treeBase.expandAllRows();
                                //  $scope.gridOptionsEventTasks.loadData();

                            }
                            if (!$scope.is_template) $scope.$parent.loadInfo($stateParams.id);
                        }, function (response) {
                            logService.error("Error with status code", response.status);
                            alert("Error al borrar")
                        });
                    }
                });

            };

        }])

.controller("EventTaskModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', 'event_task_id', 'event_id', 'type', 'uiSliderConfig', '$uibModal', 'logService',
    function (LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, event_task_id, event_id, type, uiSliderConfig, $uibModal, logService) {

    //Comprobamos si tiene permiso escritura
    $scope.allowWrite = LoginService.permissionExist("EVENTS_TASKS_WRITE");
    $scope.send_notifications = false;
    $scope.eventTask = {};
    $scope.selectedUsersIdS = [];
    $scope.type = type;
    $scope.selectEventTaskGroups = [];
    $scope.borderRight = {"border-right":"none"};
    $scope.widthGanttContainer = "10000px"; //var widthShow = angular.element("#gantt-container-shown .gantt-side").width() + angular.element('#gantt-container-shown .gantt-scrollable-header').width();

    let changedFields = [];


    $scope.GanttContainerStyle = {
        "width": "4000px"
    }

    $scope.is_template = $stateParams.is_template == 'true';

    if (angular.isUndefined(event_task_id)) {
        $scope.eventTask.event_id = event_id;
        $scope.eventTask.all_day = true;
        if (!$scope.is_template) {
            $scope.eventTask.work_progress = 0;
        }
        $scope.eventTask.event_task_id = 0;

        Restangular.all('Users').getList().then(function (results) {
            $scope.selectUsers = results;
        });

        if ($scope.type == "task") {
            let params = {
                event_id: event_id,
                is_group: true
            }
            logService.debug(params)
            Restangular.all('EventsTasks').getList(params).then(function (results) {
                $scope.selectEventTaskGroups = results;
                var withoutGroup = {
                    id: 0,
                    title: $filter('translate')('events.tasks.without_group'),
                    is_group: true
                };
                $scope.selectEventTaskGroups.unshift(withoutGroup);
                if (!$scope.$$phase) $scope.$apply();
            });
        }
    }
    else {
        Restangular.one('EventsTasks', event_task_id).get().then(function (results) {
            $scope.eventTask = results;

            if ($scope.eventTask.event_task_id == null) $scope.eventTask.event_task_id = 0;

            if ($scope.type == "task") {
                let params = {
                    event_id: $scope.eventTask.event_id,
                    is_group: true
                }
                logService.debug(params)
                Restangular.all('EventsTasks').getList(params).then(function (results) {
                    $scope.selectEventTaskGroups = results;
                    var withoutGroup = {
                        id: 0,
                        title: $filter('translate')('events.tasks.without_group'),
                        is_group: true
                    };
                    $scope.selectEventTaskGroups.unshift(withoutGroup);
                    if (!$scope.$$phase) $scope.$apply();
                });
            }

            if (!$scope.eventTask.is_group) {
                $scope.type = "task";
                $scope.newActivity = "";
                $scope.borderRight = { "border-right": "1px solid #e7eaec" };
                Restangular.all('EventsTasksActivities').getList({ event_task_id: $scope.eventTask.id }).then(function (activities) {
                    $scope.activities = activities;
                })
            } else {
                $scope.type = "group";
            }
            if (!$scope.is_template) {
                if ($scope.eventTask.date_from != null) {
                    $scope.eventTask.date_from = new Date($scope.eventTask.date_from);
                }
                if ($scope.eventTask.date_to != null) {
                    $scope.eventTask.date_to = new Date($scope.eventTask.date_to);
                }
                angular.forEach($scope.eventTask.FK_events_tasks_users_events_tasks, function (taskUser) {
                    $scope.selectedUsersIdS.push(taskUser.FK_events_tasks_users_users.id);
                });
                Restangular.all('Users').getList().then(function (results) {
                    $scope.selectUsers = results;
                    $scope.eventTask.selected_users = [];
                    angular.forEach($scope.selectUsers, function (user) {
                        if ($scope.selectedUsersIdS.indexOf(user.id) != -1) {
                            $scope.eventTask.selected_users.push(user);
                        }
                    });
                });
            }
        });
    }

    $scope.slider = {
        options: {
            min: 0,
            max: 100,
            range: 'min',
        }
    }

    $scope.setPrice = function (price) {
        $scope.price = price;
    }

    Restangular.all('TasksTypes').getList({ entity_type: "events" }).then(function (results) {
        $scope.selectTaskTypes = results;
    });

    Restangular.all('TasksStatus').getList({ entity_type: "events" }).then(function (results) {
        $scope.selectTaskStatus = results;
        if (angular.isUndefined($scope.eventTask.id)) {
            $scope.eventTask.FK_events_tasks_tasks_status = $scope.selectTaskStatus[0];
        }
    });

    $scope.AddChangedField = function (field) {
        logService.debug("Entramos en AddChangedField:")
        let fieldName = $filter('translate')(field)
        if (!changedFields.includes(fieldName)) {
            changedFields.push(fieldName)

        }
    };

    $scope.saveEventTask = function () {

        // PROBATINA Comprobar que se actualizan los valores 
            logService.debug($scope.eventTask);
            logService.debug("probamos filtro")
            logService.debug($filter('translate')('events.tasks.without_group'));
        //

        if ($scope.eventTask.event_task_id == 0) $scope.eventTask.event_task_id = null;
        $scope.eventTask.FK_events_tasks_users_events_tasks = [];
        if ($scope.type == "group") {
            $scope.eventTask.is_group = 1;
        } else {
            $scope.eventTask.task_type_id = $scope.eventTask.FK_events_tasks_tasks_types.id;
            $scope.eventTask.task_status_id = $scope.eventTask.FK_events_tasks_tasks_status.id;
            angular.forEach($scope.eventTask.selected_users, function (user) {
                $scope.eventTask.FK_events_tasks_users_events_tasks.push({
                    event_task_id: $scope.eventTask.id,
                    user_id: user.id
                })
            })
        }
        if ($scope.eventTask.date_from > $scope.eventTask.date_to && $scope.eventTask.date_to != null && typeof ($scope.eventTask.date_to) !== "undefined") {
            let hour = $scope.eventTask.date_to.getHours();
            let minutes = $scope.eventTask.date_to.getMinutes();
            logService.debug(hour + "  " + minutes);

            $scope.eventTask.date_to = angular.copy($scope.eventTask.date_from);
            $scope.eventTask.date_to.setHours(hour);
            $scope.eventTask.date_to.setMinutes(minutes);
        }

        logService.debug($scope.eventTask);

        if (angular.isDefined($scope.eventTask.id)) {
            $scope.eventTask.put().then(function (result) {
                if (angular.isDefined(result.id)) {
                    $uibModalInstance.close();
                    toastr.success($filter('translate')('events.tasks.edit_success'));
                    // if ($scope.send_notifications) sendNotification($scope.eventTask.id);
                }
            });
        } else {
            Restangular.all('eventsTasks').post($scope.eventTask).then(function (result) {
                if (angular.isDefined(result.id)) {
                    $uibModalInstance.close();
                    toastr.success($filter('translate')('events.tasks.add_success'));
                    // if ($scope.send_notifications) sendNotification(result.id);

                }
            });
        }
    }

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    //Delete desde el popup
    $scope.checkDeleteEventTask = function () {
        modalService.confirm({
            title: $filter('translate')('events.tasks.button_delete'),
            message: $filter('translate')('events.tasks.delete_message') + " " + $scope.eventTask.title + "?",
            onAccept: function () {
                Restangular.one('EventsTasks', $scope.eventTask.id).remove({send_notifications : $scope.eventTask.send_notifications}).then(function () {
                //$scope.eventTask.remove().then(function () {
                    $uibModalInstance.close();
                    if (typeof $scope.refetchEvents == 'function') $scope.refetchEvents();
                   // if ($scope.send_notifications) sendNotification($scope.eventTask.id);
                });
            }
        });
    };

    // Gestión de actividades sobre una tarea
    $scope.addActivity = function (newActivity) {

        $scope.activity = {
            title: newActivity,
            event_task_id: $scope.eventTask.id
        }
        Restangular.all('EventsTasksActivities').post($scope.activity).then(function (result) {
            $scope.activities = result;
            delete $scope.newActivity;
        });
    }

    $scope.deleteActivity = function (id) {
        Restangular.one('EventsTasksActivities', id).remove().then(function (result) {
            $scope.activities = result;
        });
    }

    $scope.showHistory = function (id) {
        let options: any = {}
        options.module = "task/notify";
        options.code = id + "";
        options.event_id = $stateParams.id;


        let $modalInstance = $uibModal.open({
            animation: true,
            template: HistoricMailsModalView,
            size: "lg",
            controller: "historicMailsModalCtrl",
            backdrop: 'static',
            keyboard: false,
            resolve: {
                options: function () {
                    return options;
                },
            }
        });
    }

}])

.controller("EventSelectModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', 'uiSliderConfig', '$uibModal', function (LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, event_task_id, event_id, type, uiSliderConfig, $uibModal) {

    $scope.selectEvents = [];
    $scope.event = {};

    Restangular.all('Events/AllEvents').getList({}).then(function (results) {
        $scope.selectEvents = results;
    });

    $scope.saveSelectEvent = function () {
        $uibModalInstance.close($scope.event);
    }

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

}]);

;
